import React, { useState, useEffect } from 'react';
import Spinner from '/Foundation/Common/code/Views/Foundation/Common/Spinner';
import './RetailerFitGuide_Select.less';

export const RetailerFitGuide_Select = ({
  dropDownValue,
  setDropDownValue,
  options,
  optionPropertyName,
  optionPropertyValue,
  name,
  loading,
  skipSuccessIcon,
}) => {
  const [showOptions, setShowOptions] = useState(false);

  useEffect(() => {
    document.addEventListener('keydown', handleEsc);
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  const handleEsc = (event) => {
    if (event.key === 'Escape') {
      setShowOptions(false);
    }
  };

  const onMouseUp = (e) => {
    const isClickInDropDown =
      ['dropdown__option', 'dropdown__select', 'dropdown__btn'].some((validClass) =>
        e.target?.classList?.contains(validClass)
      ) && e.target.closest('.thule__dropdown')?.getAttribute('data-id') === name;
    if (!isClickInDropDown) setShowOptions(false);
  };

  return (
    <div className="thule__dropdown" data-id={name}>
      <button
        disabled={loading || !options?.length > 0}
        onClick={() => {
          setShowOptions(!showOptions);
        }}
        data-value={dropDownValue?.[optionPropertyValue]}
        aria-expanded={showOptions}
        aria-controls={name}
        className={`dropdown__btn ${dropDownValue?.ImageUrl ? 'hasImage' : ''}`}
      >
        <div className={`btn__textWrapper`}>
          <div className=" d-flex align-items-start flex-column">
            <span className={'paragraph--s text-color--gray80'}>
              {name} {loading && name && <Spinner />}
            </span>
            <p className="heading6 btn__text mb-0">{dropDownValue ? dropDownValue?.[optionPropertyName] : '-'}</p>
          </div>
          {dropDownValue && !skipSuccessIcon ? (
            <i className="le-icon-check-circle"></i>
          ) : (
            <i className={`le-icon-chevron rot-${showOptions ? '90' : '270'}`}></i>
          )}
        </div>
      </button>
      <div id={name} className="dropdown__select" hidden={!showOptions}>
        {options &&
          options.length > 0 &&
          options.map((option) => {
            return (
              <button
                onClick={() => {
                  setDropDownValue(option);
                  setShowOptions(false);
                }}
                key={option[optionPropertyValue]}
                data-value={option[optionPropertyValue]}
                className={`btn dropdown__option ${option == dropDownValue ? 'dropdown__option--checked' : ''}`}
              >
                {option.ImageUrl && <img src={option.ImageUrl} alt={option.ImageAlt} />}
                <div className="select__text text-start paragraph">{option[optionPropertyName]}</div>
                {option == dropDownValue && <i className="le-icon-check ms-auto"></i>}
              </button>
            );
          })}
      </div>
    </div>
  );
};
export default RetailerFitGuide_Select;
